module.exports = __webpack_public_path__ + "images/gadget/toggle_dropdown.png";